import type { AxiosRequestConfig, AxiosResponse } from "axios";

import axiosPrivateClient from "./axiosPrivateClient";
import { runBackground, runForeground } from "./apiThrottle";

export function backgroundGet<T = unknown>(
  url: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<T>> {
  return runBackground(() => axiosPrivateClient.get<T>(url, config));
}

/** For explicit user-initiated lookups: no pacing, but still waits out a 429 cooldown. */
export function foregroundGet<T = unknown>(
  url: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<T>> {
  return runForeground(() => axiosPrivateClient.get<T>(url, config));
}
